export interface DaaluuKind {
  id: string; name: string; pips: readonly [number, number]; color: 'red' | 'white'; copies: 2 | 4; rank: number;
}
// Mappings verified from CDomino image references in the supplied article's raw
// source. Pip colors follow Chinese-domino artwork (ones/fours red, others dark).
export const DAALUU_KINDS: readonly DaaluuKind[] = [
  { id: 'daaluu', name: 'Даалуу', pips: [6, 6], color: 'red', copies: 4, rank: 12 },
  { id: 'uuluu', name: 'Үүлүү', pips: [5, 6], color: 'white', copies: 4, rank: 11 },
  { id: 'siiluu', name: 'Улаан арав', pips: [4, 6], color: 'red', copies: 4, rank: 10 },
  { id: 'bajgar', name: 'Бажгар', pips: [5, 5], color: 'white', copies: 4, rank: 10 },
  { id: 'gaval', name: 'Улаан ес', pips: [5, 4], color: 'red', copies: 2, rank: 9 },
  { id: 'degee', name: 'Цагаан ес', pips: [6, 3], color: 'white', copies: 2, rank: 9 },
  { id: 'chavgants', name: 'Чавганц', pips: [4, 4], color: 'red', copies: 4, rank: 8 },
  { id: 'savar', name: 'Тэмээ найм', pips: [5, 3], color: 'white', copies: 2, rank: 8 },
  { id: 'dongo', name: 'Дөнгө найм', pips: [6, 2], color: 'white', copies: 2, rank: 8 },
  { id: 'shor', name: 'Шор', pips: [1, 6], color: 'red', copies: 4, rank: 7 },
  { id: 'sarlag', name: 'Сарлаг долоо', pips: [5, 2], color: 'white', copies: 2, rank: 7 },
  { id: 'shanaga', name: 'Шанага долоо', pips: [4, 3], color: 'red', copies: 2, rank: 7 },
  { id: 'nohoi', name: 'Нохой зургаа', pips: [4, 2], color: 'red', copies: 2, rank: 6 },
  { id: 'buluu', name: 'Булуу', pips: [1, 5], color: 'red', copies: 4, rank: 6 },
  { id: 'chans', name: 'Чанс', pips: [3, 3], color: 'white', copies: 4, rank: 6 },
  { id: 'chuu', name: 'Чүү тав', pips: [3, 2], color: 'white', copies: 2, rank: 5 },
  { id: 'bohoon', name: 'Бөхөөн', pips: [3, 1], color: 'red', copies: 4, rank: 4 },
  { id: 'band', name: 'Банд', pips: [2, 2], color: 'white', copies: 4, rank: 4 },
  { id: 'yooz', name: 'Ёоз', pips: [1, 1], color: 'red', copies: 4, rank: 2 },
];

export interface DaaluuTile { id: string; kindId: string }
export function daaluuKind(tile: DaaluuTile): DaaluuKind {
  const kind = DAALUU_KINDS.find(item => item.id === tile.kindId);
  if (!kind) throw new Error('Unknown Daaluu tile.');
  return kind;
}
